










import { defineComponent } from '@nuxtjs/composition-api';
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';
export default defineComponent({
  name: 'BaseAlert',
  components: {
    BaseIcon,
  },
  props: {
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'secondary',
      validator: function (value) {
        // @ts-ignore migrated from ui-library
        return ['secondary', 'info', 'success', 'warning', 'danger'].includes(value);
      },
    },
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'success':
          return 'added_to_cart';
        case 'danger':
          return 'info_shield';
        default:
          return 'info_circle';
      }
    },
    colorClass() {
      switch (this.type) {
        case 'secondary':
          return 'color-secondary';
        case 'info':
          return 'color-info';
        case 'success':
          return 'color-success';
        case 'warning':
          return 'color-warning';
        case 'danger':
          return 'color-danger';
        default:
          return 'color-info';
      }
    },
  },
});
